import { render, staticRenderFns } from "./CustomerSearchBrowse.vue?vue&type=template&id=64b377cc"
import script from "./CustomerSearchBrowse.vue?vue&type=script&lang=ts"
export * from "./CustomerSearchBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b377cc')) {
      api.createRecord('64b377cc', component.options)
    } else {
      api.reload('64b377cc', component.options)
    }
    module.hot.accept("./CustomerSearchBrowse.vue?vue&type=template&id=64b377cc", function () {
      api.rerender('64b377cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/CustomerSearchBrowse.vue"
export default component.exports